/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommunityFocus } from './communityFocus';
import { CommunityStatus } from './communityStatus';
import { LocationObject } from './locationObject';
import { UpdateCommunityRequestBasic } from './updateCommunityRequestBasic';
import { Viewport } from './viewport';

export interface UpdateCharityRequest extends UpdateCommunityRequestBasic { 
    charity_focus_ids: Array<string>;
}